<template>
  <div class="BCT">
    <div class="container">
      <h2>商务汉语考试BCT</h2>
      <p>商务汉语考试（BCT）作为一项国际汉语能力标准化考试，重点考查第一语言非汉语考生在真实商务或一般工作情境中运用汉语进行交际的能力。</p>
      <p>BCT考试分为笔试和口试两部分，且二者相互独立。笔试包括BCT（A）、BCT（B）。BCT各等级与《国际汉语能力标准》《欧洲语言共同参考框架（CEFR）》的对应关系如下表所示：</p>
      <div class="__contss">
        <div class="_table">
          <div class="_row _thead">
            <div class="_col w25">
              <div class="_text">BCT</div>
            </div>
            <div class="_col w25">
              <div class="_text">词汇量</div>
            </div>
            <div class="_col w25">
              <div class="_text">国际汉语能力标准</div>
            </div>
            <div class="_col w25">
              <div class="_text">欧洲语言框架(CEFR)</div>
            </div>
          </div>
          <div class="_row">
            <div class="_col w25">
              <div class="_text z3">BCT（B）</div>
            </div>
            <div class="_col w25">
              <div class="_text">5000及以上</div>
              <div class="_text">2500</div>
              <div class="_text">1200</div>
            </div>
            <div class="_col w25">
              <div class="_text z2">五级</div>
              <div class="_text">四级</div>
            </div>
            <div class="_col w25">
              <div class="_text">C2</div>
              <div class="_text">C1</div>
              <div class="_text">B2</div>
            </div>
          </div>
          <div class="_row">
            <div class="_col w25">
              <div class="_text z3">BCT（A）</div>
            </div>
            <div class="_col w25">
              <div class="_text">600</div>
              <div class="_text">300</div>
              <div class="_text">150</div>
            </div>
            <div class="_col w25">
              <div class="_text">三级</div>
              <div class="_text">二级</div>
              <div class="_text">一级</div>
            </div>
            <div class="_col w25">
              <div class="_text">B1</div>
              <div class="_text">A2</div>
              <div class="_text">A1</div>
            </div>
          </div>
          <div class="_row">
            <div class="_col w25">
              <div class="_text"></div>
            </div>
            <div class="_col w25">
              <div class="_text">80</div>
            </div>
            <div class="_col w25">
              <div class="_text"></div>
            </div>
            <div class="_col w25">
              <div class="_text"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="shenqingTit">一、能力描述</div>
      <p>通过BCT（A）的考生可以理解并运用汉语完成日常交际和基本商务交际任务。</p>
      <p>通过BCT（B）的考生可以理解并运用汉语完成较为复杂的商务交际任务。</p>
      <p>BCT（口语）成绩分为五个能力等级，通过的考生可以理解并运用汉语完成各类商务交际任务。</p>
      <p>以考促学：激励汉语学习者的兴趣和信心，针对广大海外商务汉语学习者、一般工作情境中汉语使用者的实际需求，进一步扩大考试适用范围。</p>
      <p>以考促教：为教师和自学者提供分级别的商务汉语任务教学资源和建议，便于教学和培训有计划、有成效地提高商务学习者、使用者在真实商务或一般工作情境中运用汉语进行交际的能力。</p>
      <p>积极反馈：通过典型商务语言任务的考查，对考生完成语言任务的能力进行评价，并为考生下一步学习提供积极反馈。</p>
      <div class="shenqingTit">三、考试用途</div>
      <p>BCT成绩为下列用途提供参考依据：</p>
      <p>1．为企业评价母语非汉语员工（候选人），运用汉语进行日常工作的能力提供标准；考试成绩可作为选拔、录用和晋升的参考依据。</p>
      <p>2．为各类学校和培训机构招收商务类相关专业学生，及分班和学分授予等教育教学环节，提供学生商务汉语能力的参考。</p>
      <p>3．为商务汉语学习者自我学习、自我评价商务汉语能力提供参考。</p>
      <div class="shenqingTit">四、成绩报告</div>
      <p>考试结束一个月后，考生可登陆汉语考试服务网www.chinesetest.cn查询成绩。BCT成绩报告由国家汉办颁发。</p>
      <div class="kaoshi-fenlei">
        <van-tabs border
                  animated
                  title-active-color="#263e65">
          <van-tab title="BCT（A）">
            <div class="__contss">
              <p>商务汉语考试BCT（A）是一项国际汉语能力标准化考试，重点考查汉语非第一语言考生在真实商务或一般工作情境中运用汉语进行交际的能力，并对其能够完成的语言任务进行评价。考试遵循以用为本、听说导向、能力为重、定位职场的原则，力求贴合职场实际情况，以实用性强的语言交际内容为载体考查考生应用汉语应对工作环境需要的能力。</p>
              <div class="shenqingTit">一、考试结构</div>
              <p>商务汉语考试BCT（A）试卷共70题，分听力、阅读、书写三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w50">
                    <div class="_text">考试内容</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">试题数量</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">约20</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                    <div class="_text">20</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">30</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">10</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡（听力结束后）</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">30</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约65</div>
                  </div>
                </div>
              </div>
              <p>全部考试约70分钟（含考生填写个人信息时间5分钟）</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共10题。每题听两次。每题都是一个词或短语，试卷上提供一张图片，考生根据听到的内容判断对错。</p>
              <p>第二部分，共10题。每题听两次。每题都是一个句子，试卷上提供3张图片，考生根据听到的内容选出对应的图片。</p>
              <p>第三部分，共10题。每题听两次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上提供3个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共10题。前5题，每题提供一到两个句子或两句对话，句子中有一个空格，考生要从提供的选项中选词填空；后5题，试卷上提供一个表格或一段应用类短文，表格或短文中有5个空格，考生要从提供的选项中选词填空。</p>
              <p>第二部分，共20题。试卷上提供一系列阅读材料，如图片、表格、语段、篇章等，每个阅读材料带一到三个问题，考生要从3个选项中选出答案。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>共10题。每题提供一个带空格的句子，要求考生根据拼音提示在空格内写出正确的汉字或词语。</p>
              <div class="shenqingTit">二、商务汉语考试BCT（A）能力描述及内容举例</div>
              <p>商务汉语考试BCT（A）重视考查考生在实际汉语应用环境中的交际能力，能力描述及内容举例如下表所示：</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w20">
                    <div class="_text ha">分测验</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能力描述</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">内容举例</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂与工作或生活密切相关的用品</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">简单的日常生活用品及办公用品</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的基本数字、数量信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">签证表中最基本的内容如姓名、护照号等</div>
                    <div class="_text ha">数字（包括日期、时间、价格）</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中他人关于自身信息的简单介绍</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如姓名、年龄、国别、公司名称、职位、联系方式等</div>
                    <div class="_text ha">如兴趣爱好、身体情况等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中最基本的指示话语或要求</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如打电话、签名等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha">听力</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的基本日常用语</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如介绍、问候、欢迎、祝愿、感谢、道歉、告别等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中基本的指示话语或要求</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如询问价格、付款方式等。</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中他人基本信息的介绍或说明</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如就职公司、职位、联系方式等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中他人情况的介绍或说明</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如身体状况、工作情况等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中关于某事物的介绍或说明</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如商品特点、价格、地点介绍等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 ">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的简短通知或安排</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如会议通知、路线或时间安排等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能拼读拼音，能认读基本的汉字、词语、数字、个人信息等</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">简单的标识（如洗手间、超市、地铁、机场）</div>
                    <div class="_text ha">简单的地点（如办公室、宾馆房间） 菜单或时刻表等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha">阅读</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能认读基本的汉字、词句或简短的文字材料，看懂要求，能从简短的文字材料中获取相关信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如简单的图表，如签证表、价格表、收支表，日程表等</div>
                    <div class="_text ha">工作或生活场所中的简单用语</div>
                    <div class="_text ha">日常工作生活中最常用的名片、通知、便条、留言、短信等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能阅读日常生活或工作中常见的简短书面材料，了解大意，识别基本信息；能在题材熟悉的段落中找到所需的特定信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">商务礼仪或正式场合的常用表达方式</div>
                    <div class="_text ha">产品的简单介绍、广告等</div>
                    <div class="_text ha">简短天气预报、交通信息</div>
                    <div class="_text ha">通知、电话记录、留言、便条、短信、邮件、日程表等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能默写基本的汉字</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha"></div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 ">
                    <div class="_text ha">书写</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能根据要求填写表格</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">简单的表格，如签证表格、海关表格等</div>
                    <div class="_text ha">简单的公司内部表格，如请假单、报销单等</div>
                    <div class="_text ha">个人日程表，记下个人日常生活或工作安排</div>
                  </div>
                </div>
              </div>
              <div class="shenqingTit">三、参考词汇</div>
              <p>商务汉语考试BCT（A）以语言能力和能做量表为主要依据，在此基础上，根据多项权威汉语语料库的词频情况和国际汉语教学的实际情况设定了考试的参考词汇，共600词。</p>
              <div class="shenqingTit">四、分数体系</div>
              <p>商务汉语考试BCT（A）成绩报告，为考生提供分测验成绩和总成绩，不设合格分数；成绩报告同时对不同分数段考生进行能力描述。</p>
              <p>商务汉语考试BCT（A）全卷包含听力、阅读、书写三个分测验，全卷满分300分。分数体系，详见下表：</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w20">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">总计</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w20">
                    <div class="_text">题目数</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">30</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">30</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">70</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w20">
                    <div class="_text">分测验满分</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                </div>
              </div>
              <div class="shenqingTit">五、考试原则</div>
              <p>以考促学：激励汉语学习者的兴趣和信心，针对广大海外商务汉语学习者、一般工作情境中汉语使用者的实际需求，进一步扩大考试适用范围。</p>
              <p>以考促教：为教师和自学者提供分级别的商务汉语任务教学资源和建议，便于教学和培训有计划、有成效地提高商务学习者、使用者在真实商务或一般工作情境中运用汉语进行交际的能力。</p>
              <p>积极反馈：通过典型商务语言任务的考查，对考生完成语言任务的能力进行评价，并为考生下一步学习提供积极反馈。</p>
              <div class="shenqingTit">六、考试用途</div>
              <p>1.为企业评价母语非汉语员工（候选人），运用汉语进行日常工作的能力提供标准；考试成绩可作为选拔、录用和晋升的参考依据。</p>
              <p>2.为各类学校和培训机构招收商务类相关专业学生，及分班和学分授予等教育教学环节，提供学生商务汉语能力的参考。</p>
              <p>3.为商务汉语学习者自我学习、自我评价商务汉语能力提供参考。</p>
            </div>
          </van-tab>
          <van-tab title="BCT（B）">
            <div class="__contss">
              <p>商务汉语考试BCT（B）是一项国际汉语能力标准化考试，重点考查汉语非第一语言考生在真实商务或一般工作情境中运用汉语进行交际的能力，并 对其能够完成的语言任务进行评价。考试遵循以用为本、听说导向、能力为重、定位职场的原则，力求贴合职场实际情况，以实用性强的语言交际内容为载体，考查考生应用汉语 应对工作环境需要的能力。</p>
              <div class="shenqingTit">一、考试结构</div>
              <p>商务汉语考试BCT（B）笔试试卷共92题，分听力、阅读、写作三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w50">
                    <div class="_text">考试内容</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">试题数量</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z3">一、听力</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">20</div>
                    <div class="_text">15</div>
                    <div class="_text">15</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z3">约35</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text z2">二、阅读</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">第一部分</div>
                    <div class="_text">第二部分</div>
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">20</div>
                    <div class="_text">10</div>
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text z2">60</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">三、书写</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">2</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">40</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">填写答题卡（听力结束后）</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w25">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">/</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">92</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约140</div>
                  </div>
                </div>
              </div>
              <p>全部考试约145分钟（含考生填写个人信息时间5分钟）</p>
              <p class="ted0"><b>1．听力</b></p>
              <p>第一部分，共20题。每题听一次。每题都是两个人的两句对话，第三个人根据对话问一个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p>第二部分，共15题。每题听一次。每题都是两个人的4句对话，第三个人根据对话问一个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p>第三部分，共15题。每题听一次。播放5段话，每段话后带几个问题，试卷上每题提供4个选项，考生根据听到的内容选出答案。</p>
              <p class="ted0"><b>2．阅读</b></p>
              <p>第一部分，共20题。试卷上提供一系列阅读材料，如图片、表格、语段、篇章等，每个阅读材料带几个问题，考生要从4个选项中选出答案。</p>
              <p>第二部分，共10题。试卷上提供两篇文字，每篇文字有5个空格，考生结合上下文，从提供的7个句子选项中选出答案。</p>
              <p>第三部分，共10题。10个题分为两组，每组5题。试卷上提供4段材料以及几个问题或句子，考生要判断问题或句子与哪段材料有关。</p>
              <p class="ted0"><b>3．书写</b></p>
              <p>第一部分，共1题。试卷上提供文字或图表等形式的材料，考生根据题目要求，写一篇不少于80字的作文。</p>
              <p>第二部分，共1题。试卷上提供文字或图表等形式的材料，考生根据题目要求，写一篇不少于150字的作文。</p>
              <div class="shenqingTit">二、商务汉语考试BCT（B）的能力描述及内容举例</div>
              <p>商务汉语考试BCT（B）重视考查考生在实际汉语应用环境中的交际能力，能力描述及内容举例如下表所示：</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w20">
                    <div class="_text ha">分测验</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能力描述</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">内容举例</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的一般介绍</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如有关他人基本情况的介绍</div>
                    <div class="_text ha">如业务往来公司的情况介绍</div>
                    <div class="_text ha">如项目和产品介绍等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的基本说明</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如关于自己本职工作的说明</div>
                    <div class="_text ha">如与自己工作相关的培训内容</div>
                    <div class="_text ha">如路线说明</div>
                    <div class="_text ha">如一般日常设备用品的使用说明</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中的通知或安排</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">约会时间、地点等日常生活方面的通知</div>
                    <div class="_text ha">机场、车站、商场、医院等公共场合的广播</div>
                    <div class="_text ha">会议、工作安排、日程安排等通知</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂媒体中自己了解的新闻</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如电台、电视台等新闻</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha">听力</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">听懂有特定目标的会谈</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">打电话留言或根据留言回复</div>
                    <div class="_text ha">就工作中的问题与同事沟通</div>
                    <div class="_text ha">就设备问题与维修人员沟通</div>
                    <div class="_text ha">就产品质量与售后服务等沟通</div>
                    <div class="_text ha">就自己的职业规划与上司沟通</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂正式的会谈或会面</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">参加商务宴请等活动的基本交流</div>
                    <div class="_text ha">就自己的专业领域或业务范围面试应聘人</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能听懂工作或生活环境中关于某事或某物的讨论或会谈</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如他人关于普通话题或重要时事的讨论</div>
                    <div class="_text ha">如对商品、公司等的简单评价</div>
                    <div class="_text ha">如商务谈判中对方的主要观点</div>
                    <div class="_text ha">听懂客户的基本态度，如赞同、反对、抱怨等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能看懂工作或生活环境中的标志和标牌</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">会议室牌子、商店招牌、公司机构的名称</div>
                    <div class="_text ha">交通标志、包装警告标志、名片信息</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha">阅读</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能认读基本的汉字、词句或简短的文字材料，看懂要求，能从简短的文字材料中获取相关信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">查找表格中所需信息，如时刻表、日程安排、餐单、电话簿、清单、签证表格、请假单等</div>
                    <div class="_text ha">读懂说明性和叙述性材料中的重要信息，如 便条、邮件、信件、通知、传真、备忘录、旅游指南、路线说明、产品使用说明、工作流程说明、产品说明、投诉信等正式信函、简历、求职信、合同、项目报告、述职报告、商 务报表、规章制度等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 ">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能看懂一定长度的语言材料，把握篇章结构，并能根据上下文辨析出确保语篇语义和结构衔接的句子</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如在句子缺失的语篇结构中，根据上下文意思，从几个句子中选出一个最恰当的填入空白处</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能阅读日常生活或工作中常见的简短书面材料，了解大意，识别基本信息；能在题材熟悉的段落中找到所需的特定信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">商务礼仪或正式场合的常用表达方式</div>
                    <div class="_text ha">产品的简单介绍、广告等</div>
                    <div class="_text ha">简短天气预报、交通信息</div>
                    <div class="_text ha">通知、电话记录、留言、便条、短信、邮件、日程表等</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20 bordnone">
                    <div class="_text ha">书写</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能就基本的日常生活、工作或社交话题或图表进行客观描述，传递或表达恰当信息</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">如列清单、写日程表、写便条、写通知、写传真、写备忘录、分析图表</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w20">
                    <div class="_text ha"></div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">能就特定的话题进行记录或说明，撰写相关文件或说明，能正确反映客观情况，准确表达自己观点</div>
                  </div>
                  <div class="_col w40">
                    <div class="_text ha">会议记录，说明（如简短的路线说明、设备使用说明或工作流程说明），工作信件（如投诉信、感谢信、邀请信等），个人简历，求职信 ，报告（如调查报告、述职报告等），合同文本，或就某些话题进行论证分析</div>
                  </div>
                </div>
              </div>
              <div class="shenqingTit">三、参考词汇</div>
              <p>商务汉语考试BCT（A）以语言能力和能做量表为主要依据，在此基础上，根据多项权威汉语语料库的词频情况和国际汉语教学的实际情况设定了考试的参考词汇，共600词。</p>
              <div class="shenqingTit">四、分数体系</div>
              <p>商务汉语考试BCT（A）成绩报告，为考生提供分测验成绩和总成绩，不设合格分数；成绩报告同时对不同分数段考生进行能力描述。</p>
              <p>商务汉语考试BCT（A）全卷包含听力、阅读、书写三个分测验，全卷满分300分。分数体系，详见下表：</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w20">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">听力</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">阅读</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">书写</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">总计</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w20">
                    <div class="_text">题目数</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">30</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">30</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">10</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">70</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w20">
                    <div class="_text">分测验满分</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                  <div class="_col w20">
                    <div class="_text">100</div>
                  </div>
                </div>
              </div>
              <div class="shenqingTit">五、考试原则</div>
              <p>以考促学：激励汉语学习者的兴趣和信心，针对广大海外商务汉语学习者、一般工作情境中汉语使用者的实际需求，进一步扩大考试适用范围。</p>
              <p>以考促教：为教师和自学者提供分级别的商务汉语任务教学资源和建议，便于教学和培训有计划、有成效地提高商务学习者、使用者在真实商务或一般工作情境中运用汉语进行交际的能力。</p>
              <p>积极反馈：通过典型商务语言任务的考查，对考生完成语言任务的能力进行评价，并为考生下一步学习提供积极反馈。</p>
              <div class="shenqingTit">六、考试用途</div>
              <p>1.为企业评价母语非汉语员工（候选人），运用汉语进行日常工作的能力提供标准；考试成绩可作为选拔、录用和晋升的参考依据。</p>
              <p>2.为各类学校和培训机构招收商务类相关专业学生，及分班和学分授予等教育教学环节，提供学生商务汉语能力的参考。</p>
              <p>3.为商务汉语学习者自我学习、自我评价商务汉语能力提供参考。</p>
            </div>
          </van-tab>
          <van-tab title="BCT（口语）">
            <div class="__contss">
              <p>商务汉语考试BCT（口语）是一项国际汉语能力标准化考试，重点考查汉语非第一语言考生在真实商务或工作情境中运用汉语（口语）进行交际的能力，并对其能够完成的语言任务进行评价。BCT（口语）采用计算机半自适应考试形式，遵循“以用为本、能力为重、定位职场”的原则，根据不同考生的自身特点及职场需要，考查贴合其职场实际情况的口语表达能力，及应用汉语应对工作环境需要的能力。</p>
              <div class="shenqingTit">一、考试结构</div>
              <p>商务汉语考试BCT（B）笔试试卷共92题，分听力、阅读、写作三部分。</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w50">
                    <div class="_text">考试内容</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">试题数量</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">考试时间</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">第一部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">4</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">2</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">4</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">2</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">3</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">5</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">第五部分</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">1</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">6</div>
                  </div>
                </div>
                <div class="_row">
                  <div class="_col w75">
                    <div class="_text">登录调试、问卷调查（考试开始前）</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约5</div>
                  </div>

                </div>
                <div class="_row">
                  <div class="_col w50">
                    <div class="_text">共计</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">15</div>
                  </div>
                  <div class="_col w25">
                    <div class="_text">约25</div>
                  </div>
                </div>
              </div>
              <p>全部考试约25分钟（含考生登录系统、调试设备及作答问卷的时间）。</p>
              <p>第一部分，共4题。每题听1次，可重听1次。每题都是一个问题，试卷上每题提供一幅图片，考生参考图片回答问题。</p>
              <p>第二部分，共4题。每题听1次，可重听1次。每题都是一个问题，考生根据题目要求回答问题。</p>
              <p>第三部分，共3题。每题听1次，可重听1次。每题都是一段情景说明，以及一个要求或问题，试卷上每题提供一幅图片，考生参考图片进行回答。</p>
              <p>第四部分，共3题。每题听1次，可重听1次。每题都是一段背景说明，以及一个要求或问题，考生根据题目要求进行回答。</p>
              <p>第五部分，共1题。该题听1次，可重听1次。该题为背景说明及要求，试卷上提供4幅图片，考生根据这组图片进行回答。</p>
              <div class="shenqingTit">二、商务汉语考试BCT（口语）的能力标准</div>
              <p>商务汉语考试BCT（口语）重视考查考生在实际汉语应用环境中的交际能力，能力标准如表所示：</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w40">
                    <div class="_text">题材</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">任务</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">个人信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人基本信息，如姓名、国籍等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">路线说明</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单说明行走或行车路线、地点位置，如洗手间在何处</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">生活情况说明</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单说明日常生活安排，如每天的生活习惯</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">个人事件</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍发生在自己身上的事情，如简单的工作经历</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">他人信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍一个人，如就职的公司、职位、联系方式等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">个人基本工作信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人基本工作信息，如就职的公司、职位、联系方式等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">个人工作信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人的工作信息，如工作职责、工作范围等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">公司信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人所在公司的基本情况</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">公司产品信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人所在公司的主要产品</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">工作情况说明</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单说明工作安排，如项目时间进度、会议安排等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">一般话题</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能就普遍感兴趣的话题简单说明自己的观点，如天气、爱好等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">与工作相关的话题</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能就工作中的话题简单说明自己的观点，如对某产品的评价、对公司未来发展的看法等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">项目信息</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能简单介绍个人所在公司的主要经营项目</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">工作执行说明</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能向同事简单说明如何执行一项日常工作任务</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">与工作相关的话题</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能谈论与工作相关的话题，如个人未来的职业目标和打算等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">发言</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能就感兴趣的话题进行有准备的发言，如兴趣爱好等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">致辞</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能根据场合发表致辞，如祝酒词、开幕词、答谢词等</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">与工作相关的话题</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能进行与工作相关的话题，如报告工作进展情况</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w40">
                    <div class="_text">与工作相关的话题</div>
                  </div>
                  <div class="_col w60">
                    <div class="_text">能进行与工作相关的话题，如根据图表说明相关情况</div>
                  </div>
                </div>

              </div>
              <div class="shenqingTit">三、参考词汇</div>
              <p>商务汉语考试BCT（口语）以语言能力和能做量表为主要依据，在此基础上，综合多项权威语料库汉语词频统计的结果和商务汉语教学实际情况，设定了考试的参考词汇，共4000词。</p>
              <div class="shenqingTit">四、分数体系</div>
              <p>商务汉语考试BCT（口语）成绩报告，为考生提供各部分成绩和总成绩，不设合格分数；成绩报告同时对不同分数段考生进行能力描述。</p>
              <p>商务汉语考试BCT（口语）全卷包含五个部分，全卷满分500分。分数体系详见下表</p>
              <div class="_table">
                <div class="_row _thead">
                  <div class="_col w33">
                    <div class="_text"></div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">题目数</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">分测验满分</div>
                  </div>

                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">第一部分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">4</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">80</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">第二部分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">4</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">100</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">第三部分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">3</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">120</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">第四部分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">3</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">120</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">第五部分</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">1</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">80</div>
                  </div>
                </div>
                <div class="_row ">
                  <div class="_col w33">
                    <div class="_text">总计</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">15</div>
                  </div>
                  <div class="_col w33">
                    <div class="_text">500</div>
                  </div>
                </div>

              </div>
              <div class="shenqingTit">五、考试原则</div>
              <p>以考促学：针对商务汉语学习者、使用者的实际需求，以测评激发学习兴趣、增强学习信心，不断提升学习效果。</p>
              <p>以考促教：为教师和自学者提供分级别的商务汉语任务教学资源和建议，便于教学和培训有计划、有成效地提高商务学习者、使用者在真实商务情境中的汉语交际能力。</p>
              <p>积极反馈：通过考查典型商务语言任务，对考生在商务情景中完成语言任务的能力进行评价，并为考生下一步学习提供积极反馈。</p>
              <div class="shenqingTit">六、考试用途</div>
              <p>为企业评价母语非汉语员工（候选人），运用汉语进行日常工作的能力提供标准；考试成绩可作为选拔、录用和晋升的参考依据。</p>
              <p>为各类学校和培训机构招收商务类相关专业学生，及分班和学分授予等教育教学环节，提供学生商务汉语能力的参考。</p>
              <p>为商务汉语学习者自我学习、自我评价商务汉语能力提供参考。</p>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=formType
                 :formTitle="formtit"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm2"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <HSKForm @hideForm="hideForm"
                 ref="HSKForm"></HSKForm>
      </div>
    </van-popup>
    <van-popup v-model="showForm3"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <BCTForm @hideForm="hideForm"
                 ref="BCTForm"></BCTForm>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm'
import HSKForm from '@/components/HSKForm'
import BCTForm from '@/components/BCTForm'

export default {
  name: 'Jieji',
  components: {
    ComForm,
    HSKForm,
    BCTForm
  },
  data () {
    return {
      activeNames: ['0'],
      showForm: false,
      showForm2: false,
      showForm3: false,
      formtit: '',
      formType: ''
    }
  },
  methods: {
    hideForm () {
      this.showForm = false
      this.showForm2 = false
      this.showForm3 = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    },
    onShowForm (id, val) {
      this.formType = id
      this.formtit = val
      this.showForm = true
    }
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
h2 {
  text-align: center;
}
p {
  margin-bottom: 20px;
  font-size: 28px;
  text-indent: 2em;
  &._c {
    text-align: center;
    text-indent: 0;
  }
  &.ted0 {
    text-indent: 0;
  }
}
.container {
  padding-bottom: 0;
  h4 {
    margin: 0;
  }
  font-size: 28px;

  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
    p {
      text-indent: 0;
      margin: 0;
      margin-top: 20px;
      color: #545454;
      font-size: 26px;
      a {
        color: #263e65;
      }
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}

.cont-card {
  padding: 20px 0;
}

._baoming {
  padding: 20px;
  p {
    text-indent: 0;
    text-align: center;
  }
}
._lis {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  margin-bottom: 40px;
  overflow: hidden;
  .text {
    padding: 20px;
    h5 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 20px;
      color: #333;
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
}
.kaoshi-fenlei {
  .kaoshi-cont {
    padding: 20px;
    h3 {
      font-size: 32px;
      margin-bottom: 20px;
      span {
        font-size: 58px;
        color: #263e65;
        margin-right: 10px;
      }
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
  .btns {
    ._btn {
      display: block;
      background-color: #f6cb47;
      color: #fff;
      border-radius: 10px;
      padding: 20px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
    }
  }
}

.__contss {
  padding: 20px 0;
  ._table {
    width: 660px;
    margin: auto;
    border: 1px solid #dedede;
    margin-bottom: 10px;
    font-size: 24px;
    ._thead {
      background-color: #f1f1f1;
    }
    ._row {
      display: flex;
    }
    .w10 {
      width: 66px;
    }
    .w20 {
      width: 132px;
    }
    .w33 {
      width: 220px;
    }
    .w25 {
      width: 165px;
    }
    .w40 {
      width: 264px;
    }
    .w45 {
      width: 297px;
    }
    .w50 {
      width: 330px;
    }
    .w60 {
      width: 396px;
    }
    .w75 {
      width: 495px;
    }

    ._col {
      border-right: 1px solid #dedede;
      border-bottom: 1px solid #dedede;
      margin-bottom: -1px;
      box-sizing: border-box;
      &:last-child {
        border-right: none;
      }
      &.bordnone {
        border-bottom: none;
      }
    }
    ._text {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100px;
      padding: 0 10px;
    }
    .z2 {
      height: 200px;
    }
    .z3 {
      height: 300px;
    }
    .z4 {
      height: 400px;
    }
    .ha {
      height: auto;
      padding: 10px;
    }
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
